import {
  CheckCircleIcon,
  InfoIcon,
  WarningCircleIcon,
  WarningIcon,
  type Icon,
} from '@phosphor-icons/react'

export type ToastVariant = 'error' | 'info' | 'warning' | 'success'

export interface IToastVariantStyles {
  icon: Icon
  container: string
  iconColor: string
  titleColor: string
  bodyColor: string
  defaultTitle: string
}

// Visuals match Figma:
//   - error  → red palette  (node 2654:5007)
//   - info   → yellow palette (node 2654:4950)
// warning shares the yellow palette; success keeps the green danger token until
// a Figma spec exists for it.
export const TOAST_VARIANT_STYLES: Record<ToastVariant, IToastVariantStyles> = {
  error: {
    icon: WarningIcon,
    container: 'bg-toast-red-bg border-toast-red-border',
    iconColor: 'text-toast-red-main',
    titleColor: 'text-toast-red-secondary',
    bodyColor: 'text-toast-red-main',
    defaultTitle: 'Error',
  },
  info: {
    icon: InfoIcon,
    container: 'bg-toast-yellow-bg border-toast-yellow-border',
    iconColor: 'text-toast-yellow-main',
    titleColor: 'text-toast-yellow-secondary',
    bodyColor: 'text-toast-yellow-main',
    defaultTitle: 'Notice',
  },
  warning: {
    icon: WarningCircleIcon,
    container: 'bg-toast-yellow-bg border-toast-yellow-border',
    iconColor: 'text-toast-yellow-main',
    titleColor: 'text-toast-yellow-secondary',
    bodyColor: 'text-toast-yellow-main',
    defaultTitle: 'Warning',
  },
  success: {
    icon: CheckCircleIcon,
    container: 'bg-toast-yellow-bg border-toast-yellow-border',
    iconColor: 'text-toast-yellow-main',
    titleColor: 'text-toast-yellow-secondary',
    bodyColor: 'text-toast-yellow-main',
    defaultTitle: 'Success',
  },
}
